(function () {
  'use strict';

  const gsap = window.gsap;

  class GalleryCard {
    constructor(container) {
      this.init(container);
    }

    setup() {
      this.animate();
    }

    animate() {
      this.gsapCTX = gsap.matchMedia();

      this.gsapCTX.add(
        '(min-width: 768px)',
        () => {
          const animType = this.DOM.card.getAttribute('data-anims');
          const hasQuickView = this.DOM.card.getAttribute('data-quick-view');
          const hasQuickBuy = this.DOM.card.getAttribute('data-quick-add');

          const tl = gsap.timeline({
            paused: true,
            defaults: {
              ease: 'power4.inOut',
              duration: 1,
            },
          });

          if (hasQuickView === 'true')
            tl.to('.js-anims-tag-view', { opacity: 1, y: 30, duration: 0.25 }, 0).to(
              '.js-anim-tags-header',
              { y: 40, duration: 0.25 },
              0,
            );
          if (hasQuickBuy === 'true') {
            tl.to('.js-anims-tag-add', { opacity: 1, y: 50, duration: 0.25 }, 0);
          }

          switch (animType) {
            case 'fade-in-out':
              tl.to('.js-anims-image', { scale: 0.5, autoAlpha: 0 }, 0).to('.js-anims-alt-media', { autoAlpha: 1 }, 0);
              break;
            case 'swap-x':
              tl.to('.js-anims-image', { xPercent: -100 }, 0).to(
                '.js-anims-alt-media',
                { xPercent: 0, opacity: 1, startAt: { xPercent: 100 } },
                0,
              );
              break;
            case 'swap-y-1':
              tl.to('.js-anims-image', { yPercent: -100 }, 0).to(
                '.js-anims-alt-media',
                { yPercent: 0, opacity: 1, startAt: { yPercent: 100 } },
                0,
              );
              break;
            case 'zoom':
              tl.to('.js-anims-image', { scale: 1.1 }, 0);
              break;
            case 'text-out':
              tl.to('.js-anims-image', { yPercent: -100 }, 0)
                .to('.js-anims-alt-media', { yPercent: 0, opacity: 1, startAt: { yPercent: 100 } }, 0)
                .to('.js-anims-cart-icon', { xPercent: 150, scale: 0.5 }, 0)
                .from('.js-anims-cart-button', { xPercent: 110 }, 0);
              break;
            case 'none':
              break;
          }

          const handleMouseEnter = () => { tl.play(); };
          const handleMouseLeave = () => { tl.reverse(); };

          const handleFocusIn = () => { tl.play(); };
          const handleFocusOut = (e) => {
            if (this.DOM.card.contains(e.relatedTarget)) return;
            tl.reverse();
          };

          this.DOM.card.addEventListener('mouseenter', handleMouseEnter);
          this.DOM.card.addEventListener('mouseleave', handleMouseLeave);
          this.DOM.card.addEventListener('focusin', handleFocusIn);
          this.DOM.card.addEventListener('focusout', handleFocusOut);

          return () => {
            this.DOM.card.removeEventListener('mouseenter', handleMouseEnter);
            this.DOM.card.removeEventListener('mouseleave', handleMouseLeave);
            this.DOM.card.removeEventListener('focusin', handleFocusIn);
            this.DOM.card.removeEventListener('focusout', handleFocusOut);
          };
        },
        this.DOM.card,
      );
      this.gsapCTX.add(
        '(max-width: 767px)',
        () => {
          const animType = this.DOM.card.getAttribute('data-anims');
          const hasQuickView = this.DOM.card.getAttribute('data-quick-view');
          const hasQuickBuy = this.DOM.card.getAttribute('data-quick-add');
          const color = window.getComputedStyle(this.DOM.card).getPropertyValue('--selected-text-color');

          const tl = gsap.timeline({
            paused: true,
            defaults: {
              ease: 'power4.inOut',
              duration: 1,
            },
          });

          switch (animType) {
            case 'fade-in-out':
              tl.to('.js-anims-image', { scale: 0.5, autoAlpha: 0 }, 0).to('.js-anims-alt-media', { autoAlpha: 1 }, 0);
              break;
            case 'swap-x':
              tl.to('.js-anims-image', { xPercent: -100 }, 0).to(
                '.js-anims-alt-media',
                { xPercent: 0, opacity: 1, startAt: { xPercent: 100 } },
                0,
              );
              break;
            case 'swap-y-1':
              tl.to('.js-anims-image', { yPercent: -100 }, 0).to(
                '.js-anims-alt-media',
                { yPercent: 0, opacity: 1, startAt: { yPercent: 100 } },
                0,
              );
              break;
            case 'zoom':
              tl.to('.js-anims-image', { scale: 1.1 }, 0);
              break;
            case 'text-out':
              tl.to('.js-anims-image', { yPercent: -100 }, 0).to(
                '.js-anims-alt-media',
                { yPercent: 0, opacity: 1, startAt: { yPercent: 100 } },
                0,
              );
              break;
            case 'none':
              break;
          }

          const handleMouseEnter = () => { tl.play(); };
          const handleMouseLeave = () => { tl.reverse(); };

          const handleFocusIn = () => { tl.play(); };
          const handleFocusOut = (e) => {
            if (this.DOM.card.contains(e.relatedTarget)) return;
            tl.reverse();
          };

          this.DOM.card.addEventListener('mouseenter', handleMouseEnter);
          this.DOM.card.addEventListener('mouseleave', handleMouseLeave);
          this.DOM.card.addEventListener('focusin', handleFocusIn);
          this.DOM.card.addEventListener('focusout', handleFocusOut);

          return () => {
            this.DOM.card.removeEventListener('mouseenter', handleMouseEnter);
            this.DOM.card.removeEventListener('mouseleave', handleMouseLeave);
            this.DOM.card.removeEventListener('focusin', handleFocusIn);
            this.DOM.card.removeEventListener('focusout', handleFocusOut);
          };
        },
        this.DOM.card,
      );
    }

    destroy() {
      if (this.DOM) {
        this.gsapCTX?.revert();
      }
    }

    init(container) {
      if (container) {
        this.DOM = {};
        this.DOM.card = container;

        this.setup();
      }
    }
  }

  window.Universe = window.Universe || {};
  window.Universe.GalleryCard = GalleryCard;
})();
